import { IUsersAutocompleteOptionProps } from '../UsersAutocomplete.types';

const extractUsername = (value: string | IUsersAutocompleteOptionProps) => {
  if (typeof value === 'string') {
    return value || '';
  }

  return value?.username || '';
};

export default extractUsername;
